import { render, staticRenderFns } from "./borrowDialog.vue?vue&type=template&id=3def0fbd&scoped=true"
import script from "./borrowDialog.vue?vue&type=script&lang=js"
export * from "./borrowDialog.vue?vue&type=script&lang=js"
import style0 from "./borrowDialog.vue?vue&type=style&index=0&id=3def0fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3def0fbd",
  null
  
)

export default component.exports